import React, { useState } from "react";

import { apiURL } from "../../api/index";

function ServiceModal(props) {
  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [price, setPrice] = useState("");
  const [message, setMessage] = useState("");
  const [isServiceAddedSuccessfully, setIsServiceAddedSuccessfully] =
    useState(false);

  const createService = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("title", title);
      formData.append("image", image);
      formData.append("price", price);
      const res = await fetch(`${apiURL}/createservice`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      console.log(data);

      if (data.message === "Service Added") {
        setMessage("The Service Has Been Added Successfully!");
        setIsServiceAddedSuccessfully(true);
        setTimeout(() => {
          props.closeServiceModal();
        }, 2000);
        setCategory("");
        setTitle("");
        setImage(null);
        setPrice("");
      } else if (data.message === "Invalid Details") {
        setMessage("Invalid Details OR File Type Error!");
        setIsServiceAddedSuccessfully(false);
      }
    } catch (error) {
      setMessage("Unable To Send Data Due To Network Error!");
      console.log(error);
    }
  };

  const updateService = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("title", title);
      formData.append("image", image);
      formData.append("price", price);
      const res = await fetch(`${apiURL}/updateservice/${props.serviceId}`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      console.log(data);

      if (data.message === "Service Updated") {
        setMessage("The Service Has Been Updated Successfully!");
        setIsServiceAddedSuccessfully(true);
        setTimeout(() => {
          props.closeServiceModal();
        }, 2000);
        setCategory("");
        setTitle("");
        setImage(null);
        setPrice("");
      } else if (data.message === "Invalid Details") {
        setMessage("Invalid Details OR File Type Error!");
        setIsServiceAddedSuccessfully(false);
      }
    } catch (error) {
      setMessage("Unable To Send Data Due To Network Error!");
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={
          isServiceAddedSuccessfully
            ? "bg-green-600 text-white font-primary text-center"
            : "bg-amber-600 text-white font-primary text-center"
        }
      >
        {message}
      </div>
      <div className="absolute w-[100%] h-[100vh] bg-white bg-opacity-[0.6] justify-center items-center flex">
        <form
          encType="multipart/form-data"
          className="flex flex-col w-96 h-[60vh] mx-auto justify-center items-left p-5 bg-primary text-white rounded-sm"
        >
          <select
            name="category"
            className="text-primary my-2 p-2 outline-none"
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">--Select Category--</option>
            <option value="Cars">Cars</option>
            <option value="Bikes">Bikes</option>
            <option value="Generators">Generators</option>
            <option value="Refrigerators">Refrigerators</option>
          </select>
          <input
            onChange={(e) => setTitle(e.target.value)}
            className="my-2 p-2 text-black outline-none"
            type="text"
            placeholder="Service Title..."
            name="title"
          />

          <input
            onChange={(e) => setImage(e.target.files[0])}
            className="my-2 p-2 outline-none"
            type="file"
            name="image"
          />
          <input
            onChange={(e) => setPrice(e.target.value)}
            className="my-2 p-2 text-black outline-none"
            type="number"
            placeholder="Service Price..."
            name="price"
          />

          {props.operation === "create" ? (
            <button
              type="submit"
              className="bg-secondary py-2 mt-2"
              onClick={(e) => createService(e)}
            >
              Create
            </button>
          ) : (
            <button
              type="submit"
              className="bg-secondary py-2 mt-2"
              onClick={(e) => updateService(e)}
            >
              Update
            </button>
          )}

          <button
            type="submit"
            className="bg-red-600 py-2 mt-2"
            onClick={props.closeServiceModal}
          >
            Cancel
          </button>
        </form>
      </div>
    </>
  );
}

export default ServiceModal;
